export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_jp-3c3443cc40f009c36053e9777073aa24.png";